<ew-mat-dialog-custom>
  <div class="p-5">
    <h1 mat-dialog-title>{{ 'sharePublicLink:title' | translate }}</h1>
    <mat-dialog-content>
      <h2>{{ 'sharePublicLink:subtitle' | translate }}</h2>
      <hr class="mb-2" />
      <ng-container *ngIf="publicLinks.length; else noLink">
        <ul class="list-none py-3">
          <li class="mb-3" *ngFor="let publicLink of publicLinks">
            <div class="flex items-center gap-1">
              <div
                class="truncate relative max-w-100 rounded-full bg-gray-100 p-2 -ml-2">
                {{ publicLink.url }}
              </div>
              <a [href]="publicLink.url" target="_blank">
                <button
                  class="border"
                  mat-icon-button
                  matTooltip="{{ 'shared:open' | translate }}"
                  aria-label="Open link in new tab">
                  <mat-icon class="fa-regular fa-external-link"></mat-icon>
                </button>
              </a>
              <button
                class="border"
                mat-icon-button
                [cdkCopyToClipboard]="publicLink.url"
                (cdkCopyToClipboardCopied)="onCopied()"
                matTooltip="{{ 'shared:copy' | translate }}"
                aria-label="Copy link to clipboard">
                <mat-icon class="fa-regular fa-copy"></mat-icon>
              </button>
            </div>
            <div class="text-xs">
              {{ 'sharePublicLink:createdDate' | translate }}
              {{ publicLink.createdAt | date: 'd MMM y' }}
            </div>
          </li>
        </ul>
      </ng-container>
      <ng-template #noLink>
        <div class="py-7">
          {{ 'sharePublicLink:noLink' | translate }}
        </div>
      </ng-template>
      <hr class="my-2" />
    </mat-dialog-content>
    <mat-dialog-actions class="justify-center" *ngIf="!publicLinks.length">
      <button
        class="w-1/2 rounded-md"
        mat-flat-button
        color="primary"
        (click)="generatePublicLink()">
        {{ 'sharePublicLink:btnGenerate' | translate }}
      </button>
    </mat-dialog-actions>
  </div>
</ew-mat-dialog-custom>
